// Role configuration for Suivi BTP
export const ROLES = {
  super_admin: { label: "Super Admin", short: "Super Admin", color: "bg-red-500/20 text-red-400" },
  admin_entreprise: { label: "Admin Entreprise", short: "Admin", color: "bg-orange-500/20 text-orange-400" },
  conducteur_travaux: { label: "Conducteur de travaux", short: "Conducteur", color: "bg-blue-500/20 text-blue-400" },
  chef_chantier: { label: "Chef de chantier", short: "Chef", color: "bg-emerald-500/20 text-emerald-400" },
};

export const getRoleLabel = (role) => ROLES[role]?.label || role;
export const getRoleShort = (role) => ROLES[role]?.short || role;
export const getRoleColor = (role) => ROLES[role]?.color || "bg-zinc-700 text-zinc-400";
export const isSuperAdmin = (role) => role === "super_admin";
